import { useMemo } from 'react'

import {
  CompositeTableTemplate,
  renderCellGrayZeros,
} from 'app/common/templates-next/table-template'
import { ReportAverageCheckData } from 'app/dataTypes/reports/data/common/averageCheck'

import {
  columnKeysLeft,
  columnKeysLeftHeaders,
  columnKeysRight,
  columnKeysRightHeaders,
  createColumnKeysMain,
  createColumnKeysMainHeaders,
  createData,
  createDataProps,
  createDataTotal,
  createHeaderCells,
  createHeaderCellsProps,
  createTotalDataProps,
  renderFooterCell,
  tdPropsByRowAndColumnKey,
} from './table-options'

export const AverageCheckTable = ({
  data,
  pending,
}: {
  data: ReportAverageCheckData
  pending: boolean
}) => {
  const tableData = useMemo(() => {
    const mainColumnKeys = createColumnKeysMain(data.dates)
    return {
      columnKeysLeft,
      columnKeysLeftHeaders,
      columnKeysMain: mainColumnKeys,
      columnKeysMainHeaders: createColumnKeysMainHeaders(data.dates),
      columnKeysRight,
      columnKeysRightHeaders,
      header: createHeaderCells(),
      headerProps: createHeaderCellsProps(),
      data: createData({ orgs: data.orgs, columnKeysMain: mainColumnKeys }),
      dataProps: createDataProps(),
      total: createDataTotal({
        orgsTotalByDateIndex: data.orgsTotalByDateIndex,
        totalOverall: data.totalOverall,
        columnKeysMain: mainColumnKeys,
      }),
      totalProps: createTotalDataProps(),
    }
  }, [data])

  return (
    <CompositeTableTemplate
      data={tableData}
      loading={pending}
      renderCell={renderCellGrayZeros}
      renderFooterCell={renderFooterCell}
      tdPropsByRowAndColumnKey={tdPropsByRowAndColumnKey}
      borderTop
    />
  )
}
